const defaultStyle = `
    p {
        font-size: 17px !important;
        line-height: 32px !important;
        box-sizing: border-box;
    }
    table{
        width: 99%;
        margin:auto;
        border-collapse: collapse;
        font-size: 17px !important;
        line-height: 32px !important;
    }
    table thead th {
        border-collapse: collapse;
        background-color: #d3d3d3;
        border:1px solid #f5f5f5;
        padding:3px 0px;
        text-align:center;
        color:#333333;
    }
    td {
        border:1px solid #f5f5f5;
        padding:2px 2px;
    }
`;

const autoWidthHtmlFN = (content, style) => `
<html>
<head>
  <meta name="viewport" content="initial-scale=1.0, user-scalable=no" />
    <style>${style || defaultStyle}</style>
</head>
<body>
${content}
</body>
</html>
`;

export {
    autoWidthHtmlFN
};

